import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {FidjiNetworkService, IMPublication} from '@immanens-com/fidji-api-module';
import { UserControllerService } from '../services/user/user-controller.service';
import { LibraryControllerService } from '../services/library/library-controller.service';

@Injectable()
export class ConnectionGuard implements CanActivate {

  constructor(private networkService: FidjiNetworkService,
              private userCtrl: UserControllerService,
              private libraryCtrl: LibraryControllerService,
              private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      // for each call, check online state (go to app.component.ts for result handle)
    this.networkService.checkIsOnlineState();

    if (this.userCtrl.user != null) {
      // in any case, if user is logged, routed anywhere is possible
      return true;
    }

    // else user unlog :

    // library is routed only if local document :
    if (next.url[0] && next.url[0].path === 'library') {
      return this.libraryCtrl.localPublicationsChange.map(pub => {
        if (pub.length > 0) {
          return true;
        } else {
          this.router.navigate(['/login']);
          return false;
        }
     });
    }
    // in any other case (not log and not library) : go to login
    this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/connection.guard.ts